<template>
    <div class="row" v-if="!email">
        <div class="col-12">
            <div class="card bg-warning-subtle mb-3">
                <div class="row no-gutters">
                    <div class="col-2">
                        <div class="card-body text-elev-blue">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                                 stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                                 class="card-icon lucide lucide-mail-question-mark-icon lucide-mail-question-mark">
                                <path d="M22 10.5V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v12c0 1.1.9 2 2 2h12.5"/>
                                <path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7"/>
                                <path d="M18 15.28c.2-.4.5-.8.9-1a2.1 2.1 0 0 1 2.6.4c.3.4.5.8.5 1.3 0 1.3-2 2-2 2"/>
                                <path d="M20 22v.01"/>
                            </svg>
                        </div>
                    </div>
                    <div class="col-10">
                        <div class="card-body pb-0">
                            <h5 class="card-title text-xs">{{ $t('E-post') }}</h5>
                        </div>
                        <div class="card-body pt-1">
                            {{ $t('Hei {name}, vi mangler epostadressen din, vennligst angi den her:', {name: name}) }}
                            <div class="hr-wrapper">
                                <hr>
                            </div>
                            <div class="d-flex gap-4">
                                <a class="btn btn-primary btn-block" href="/profile">{{ $t('Profil') }}</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
    const props = defineProps(['name', 'email']);
</script>